function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/* eslint-disable no-prototype-builtins */
import EVENTS from '../events';
import Speed from './speed';
var COMPLETE_STATUS = {
  DONE: 'done',
  NOBUFFER: 'nobuffer'
};
var LOADER_EVENTS = EVENTS.LOADER_EVENTS;
var READ_STREAM = 0;
var READ_TEXT = 1;
var READ_JSON = 2;
var READ_BUFFER = 3;

var FetchLoader = /*#__PURE__*/function () {
  function FetchLoader(configs) {
    _classCallCheck(this, FetchLoader);

    this.configs = Object.assign({}, configs);
    this.url = null;
    this.status = 0;
    this.error = null;
    this._reader = null;
    this._canceled = false;
    this._destroyed = false;
    this.readtype = this.configs.readtype;
    this.buffer = this.configs.buffer || 'LOADER_BUFFER';
    this._loaderTaskNo = 0;
    this._ttfb = 0;
    this._responseHeader = null;
    this._speed = new Speed();

    if (window.AbortController) {
      this.abortControllerEnabled = true;
    }
  }

  _createClass(FetchLoader, [{
    key: "init",
    value: function init() {
      this.on(LOADER_EVENTS.LADER_START, this.load.bind(this));
    }
  }, {
    key: "fetch",
    value: function (_fetch) {
      function fetch(_x, _x2, _x3) {
        return _fetch.apply(this, arguments);
      }

      fetch.toString = function () {
        return _fetch.toString();
      };

      return fetch;
    }(
    /**
     * @param {string}      url
     * @param {RequestInit} params
     * @param {number}      timeout
     * @return {Promise<unknown>}
     */
    function (url, params, timeout) {
      var _this2 = this;

      var timer = null;

      if (this.abortControllerEnabled) {
        this.abortController = new window.AbortController();
      }

      Object.assign(params, {
        signal: this.abortController ? this.abortController.signal : undefined
      });
      var start = new Date().getTime();
      return Promise.race([fetch(url, params), new Promise(function (resolve, reject) {
        timer = setTimeout(function () {
          /* eslint-disable-next-line */
          reject({
            code: 999,
            message: 'fetch timeout'
          });

          if (_this2.abortController) {
            _this2.abortController.abort();
          }
        }, timeout || 1e4); // 10s
      })]).then(function (response) {
        var _this2$_speed;

        if (timer) {
          clearTimeout(timer);
          timer = null;
        }

        (_this2$_speed = _this2._speed) === null || _this2$_speed === void 0 ? void 0 : _this2$_speed.recordLoading(response.headers);
        var end = new Date().getTime();

        _this2.emit(LOADER_EVENTS.LOADER_TTFB, {
          url: url,
          responseUrl: response.url,
          start: start,
          end: end,
          elapsed: end - start
        });

        return response;
      });
    }
    /**
     * @param {string}      url
     * @param {RequestInit} params
     * @param {number}      retryTimes
     * @param {number}      totalRetry
     * @param {number}      delayTime
     * @return {Promise<{ok}>}
     */
    )
  }, {
    key: "internalLoad",
    value: function internalLoad(url, params, retryTimes, totalRetry) {
      var _this3 = this;

      var delayTime = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 0;
      var loadTimeout = arguments.length > 5 ? arguments[5] : undefined;
      var maxReaderInterval = arguments.length > 6 ? arguments[6] : undefined;
      if (this._destroyed) return;
      this.loading = true;
      return this.fetch(this.url, params, loadTimeout).then(function (response) {
        !_this3._destroyed && _this3.emit(LOADER_EVENTS.LOADER_RESPONSE_HEADERS, _this3.TAG, response.headers);
        _this3._responseHeader = response.headers;

        if (response.ok) {
          _this3.status = response.status;
          Promise.resolve().then(function () {
            _this3._onFetchResponse(response, maxReaderInterval);
          });
          return Promise.resolve(response);
        }

        if (retryTimes-- > 0) {
          _this3._retryTimer = setTimeout(function () {
            _this3.emit(LOADER_EVENTS.LOADER_RETRY, _this3.TAG, {
              response: response,
              reason: 'response not ok',
              retryTime: totalRetry - retryTimes
            });

            return _this3.internalLoad(url, params, retryTimes, totalRetry, delayTime, loadTimeout, maxReaderInterval);
          }, delayTime);
        } else {
          _this3.loading = false;

          _this3.emit(LOADER_EVENTS.LOADER_ERROR, _this3.TAG, {
            code: response.status || 21,
            message: "".concat(response.status, " (").concat(response.statusText, ")")
          });
        }
      })["catch"](function (error) {
        if (_this3._destroyed) {
          _this3.loading = false;
          return;
        }

        if (retryTimes-- > 0) {
          _this3._retryTimer = setTimeout(function () {
            _this3.emit(LOADER_EVENTS.LOADER_RETRY, _this3.TAG, {
              error: error,
              reason: 'fetch error',
              retryTime: totalRetry - retryTimes
            });

            return _this3.internalLoad(url, params, retryTimes, totalRetry, delayTime, loadTimeout, maxReaderInterval);
          }, delayTime);
        } else {
          _this3.loading = false;

          if (error && error.name === 'AbortError') {
            return;
          }

          _this3.emit(LOADER_EVENTS.LOADER_ERROR, _this3.TAG, Object.assign({
            code: 21
          }, error));
        }
      });
    }
    /**
     * @param {string}      url
     * @param {RequestInit} opts
     * @param {retryCount, retryDelay, loadTimeout}  pluginConfig
     * @return {Promise<{ok}>}
     */

  }, {
    key: "load",
    value: function load(url) {
      var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
          retryCount = _ref.retryCount,
          retryDelay = _ref.retryDelay,
          loadTimeout = _ref.loadTimeout,
          maxReaderInterval = _ref.maxReaderInterval;

      if (!url) {
        this.emit(LOADER_EVENTS.LOADER_ERROR, this.TAG, {
          code: 0,
          message: 'empty url'
        });
        return;
      }

      retryCount = retryCount === undefined ? 3 : retryCount;
      this.url = url;
      this._canceled = false; // TODO: Add Ranges

      var params = this.getParams(opts);
      return this.internalLoad(url, params, retryCount, retryCount, retryDelay, loadTimeout, maxReaderInterval);
    }
  }, {
    key: "_onFetchResponse",
    value: function _onFetchResponse(response, maxReaderInterval) {
      var _this4 = this;

      var _this = this;

      var buffer = this._context.getInstance(this.buffer);

      this._loaderTaskNo++;
      var taskno = this._loaderTaskNo;

      if (response.ok === true) {
        var req;

        switch (this.readtype) {
          case READ_JSON:
            req = response.json();
            break;

          case READ_TEXT:
            req = response.text();
            break;

          case READ_BUFFER:
            req = response.arrayBuffer();
            break;

          case READ_STREAM:
          default:
            return this._onReader(response.body.getReader(), taskno, maxReaderInterval);
        }

        if (!req) return;
        req.then(function (data) {
          var _this4$_speed;

          (_this4$_speed = _this4._speed) === null || _this4$_speed === void 0 ? void 0 : _this4$_speed.recordLoaded();
          _this.loading = false;

          if (!_this._canceled && !_this._destroyed) {
            if (buffer) {
              buffer.push(data instanceof ArrayBuffer ? new Uint8Array(data) : data);

              _this.emit(LOADER_EVENTS.LOADER_COMPLETE, buffer);
            } else {
              _this.emit(LOADER_EVENTS.LOADER_COMPLETE, data);
            }
          }
        })["catch"](function () {});
      }
    }
  }, {
    key: "_onReader",
    value: function _onReader(reader, taskno, maxReaderInterval) {
      var _this5 = this;

      var buffer = this._context.getInstance(this.buffer);

      if (!buffer && this._reader || this._destroyed) {
        try {
          this._reader.cancel();
        } catch (e) {// DO NOTHING
        }
      }

      this._reader = reader;

      if (this.loading === false) {
        return;
      } // reader read function returns a Promise. get data when callback and has value.done when disconnected.
      // read方法返回一个Promise. 回调中可以获取到数据。当value.done存在时，说明链接断开。


      this._noDataTimer = setTimeout(function () {
        if (_this5.loading === false) return;

        _this5.emit(LOADER_EVENTS.LOADER_COMPLETE, COMPLETE_STATUS.NOBUFFER);
      }, maxReaderInterval || 3000);
      this._reader && this._reader.read().then(function (val) {
        var _this5$_speed2;

        clearTimeout(_this5._noDataTimer);

        if (_this5._canceled || _this5._destroyed) {
          if (_this5._reader) {
            try {
              _this5._reader.cancel();
            } catch (e) {// DO NOTHING
            }
          }

          return;
        }

        if (val.done) {
          var _this5$_speed;

          _this5.loading = false;
          _this5.status = 0;
          (_this5$_speed = _this5._speed) === null || _this5$_speed === void 0 ? void 0 : _this5$_speed.destroy();
          Promise.resolve().then(function () {
            _this5.emit(LOADER_EVENTS.LOADER_COMPLETE, COMPLETE_STATUS.DONE);
          });
          return;
        }

        buffer.push(val.value);
        (_this5$_speed2 = _this5._speed) === null || _this5$_speed2 === void 0 ? void 0 : _this5$_speed2.recordChunk(val.value.byteLength);
        Promise.resolve().then(function () {
          _this5.emit(LOADER_EVENTS.LOADER_DATALOADED, buffer);
        });
        return _this5._onReader(reader, taskno, maxReaderInterval);
      })["catch"](function (error) {
        clearTimeout(_this5._noDataTimer);
        _this5.loading = false;
        if (error && error.name === 'AbortError') return;

        _this5.emit(LOADER_EVENTS.LOADER_ERROR, _this5.TAG, error);
      });
    }
    /**
     *
     * @param {RequestInit} opts
     * @return {{mode: string, headers: Headers, cache: string, method: string}}
     */

  }, {
    key: "getParams",
    value: function getParams(opts) {
      var options = Object.assign({}, opts);
      var headers = new Headers();
      var params = {
        method: 'GET',
        headers: headers,
        mode: 'cors',
        cache: 'default'
      }; // add custmor headers
      // 添加自定义头

      if (_typeof(this.configs.headers) === 'object') {
        var configHeaders = this.configs.headers;

        for (var key in configHeaders) {
          if (configHeaders.hasOwnProperty(key)) {
            headers.append(key, configHeaders[key]);
          }
        }
      }

      if (_typeof(options.headers) === 'object') {
        var optHeaders = options.headers;

        for (var _key in optHeaders) {
          if (optHeaders.hasOwnProperty(_key)) {
            headers.append(_key, optHeaders[_key]);
          }
        }
      }

      if (options.cors === false) {
        params.mode = 'same-origin';
      } // withCredentials is disabled by default
      // withCredentials 在默认情况下不被使用。


      if (options.withCredentials) {
        params.credentials = 'include';
      } // TODO: Add ranges;


      return params;
    } // bps

  }, {
    key: "avgSpeed",
    get: function get() {
      var _this$_speed;

      return ((_this$_speed = this._speed) === null || _this$_speed === void 0 ? void 0 : _this$_speed.avgSpeed) || 0;
    } // bps

  }, {
    key: "recentSpeed",
    get: function get() {
      var _this$_speed2;

      return ((_this$_speed2 = this._speed) === null || _this$_speed2 === void 0 ? void 0 : _this$_speed2.recentSpeed) || 0;
    } // KBps

  }, {
    key: "currentSpeed",
    get: function get() {
      var _this$_speed3;

      return ((_this$_speed3 = this._speed) === null || _this$_speed3 === void 0 ? void 0 : _this$_speed3.avgSpeed) / 8000;
    }
  }, {
    key: "totalByteSize",
    get: function get() {
      var _this$_speed4;

      return (_this$_speed4 = this._speed) === null || _this$_speed4 === void 0 ? void 0 : _this$_speed4.totalByteSize;
    }
  }, {
    key: "responseHeader",
    get: function get() {
      return this._responseHeader;
    }
  }, {
    key: "cancel",
    value: function cancel() {
      var _this$_speed5;

      if (this._reader) {
        try {
          var c = this._reader.cancel();

          c["catch"] && c["catch"](function (e) {});
        } catch (e) {// 防止failed: 200错误被打印到控制台上
        }

        this._reader = null;
        this.loading = false;
      }

      clearTimeout(this._noDataTimer);
      this._canceled = true;

      if (this.abortController) {
        this.abortController.abort();
      }

      (_this$_speed5 = this._speed) === null || _this$_speed5 === void 0 ? void 0 : _this$_speed5.clean();
    }
  }, {
    key: "destroy",
    value: function destroy() {
      var _this$_speed6;

      this._destroyed = true;
      this._responseHeader = null;
      clearTimeout(this._retryTimer);
      clearTimeout(this._noDataTimer);
      this.cancel();
      (_this$_speed6 = this._speed) === null || _this$_speed6 === void 0 ? void 0 : _this$_speed6.destroy();
      this._speed = null;
    }
  }], [{
    key: "isSupported",
    value: function isSupported() {
      return !!window.fetch;
    }
  }, {
    key: "type",
    get: function get() {
      return 'loader';
    }
  }]);

  return FetchLoader;
}();

export default FetchLoader;